var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M18.651 3.866H1.35c-.193 0-.349.167-.349.374v4.565c0 .207.156.374.349.374H18.65c.193 0 .349-.167.349-.374V4.24c0-.207-.156-.374-.349-.374ZM2.333 9.384v19.957a.073.073 0 0 0 .019.05.065.065 0 0 0 .021.015.06.06 0 0 0 .025.005h15.203a.06.06 0 0 0 .047-.02.07.07 0 0 0 .018-.05V9.384M6 13v13.315M9.881 13v13.315M13.762 13v13.315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D253C",
    d: "M7 3.662v-2.28a.406.406 0 0 1 .104-.27A.336.336 0 0 1 7.356 1h5.288a.335.335 0 0 1 .252.112.384.384 0 0 1 .104.27v2.275"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7 3.662v-2.28a.406.406 0 0 1 .104-.27A.336.336 0 0 1 7.356 1h5.288a.335.335 0 0 1 .252.112.384.384 0 0 1 .104.27v2.275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5d6e67bf8684f3d987dea0eca949992d.svg";
export { ForwardRef as ReactComponent };